module.exports = __webpack_public_path__ + "media/images/icons/cross-white-7907b674c100f8bf8e15210411c70b9e.svg";